<template>
  <AppDialog :width="800">
    <v-card>
      <v-card-title>{{ form._id }}</v-card-title>
      <v-card-text>
        <CopyBtn :value="JSON.stringify(form)" msg="Copied" />
        <pre id="json">
          {{ form }}
        </pre>
      </v-card-text>
    </v-card>
  </AppDialog>
</template>

<script setup lang="ts">
import type { SerializedDb, VisaForm } from '~/types';

defineProps<{
  form: SerializedDb<VisaForm>;
}>();
</script>